var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndorsement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.999 511.999",
    height: 512,
    viewBox: "0 0 511.999 511.999",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m441.366 313.25c7.351-8.103 11.834-18.849 11.834-30.625 0-25.157-20.467-45.625-45.624-45.625h-96.552v-87.42c0-37.384-30.414-67.798-67.799-67.798h-26.162v46.952c0 24.106-5.639 48.274-16.306 69.892s-26.418 40.796-45.55 55.461l-5.975 4.58h-90.433v229.57h92.96l67.534 23.761 188.282.001c25.157 0 45.624-20.467 45.624-45.625 0-11.776-4.483-22.522-11.834-30.625 7.351-8.103 11.834-18.849 11.834-30.625s-4.483-22.522-11.833-30.625c7.35-8.103 11.833-18.849 11.833-30.625s-4.483-22.521-11.833-30.624zm-352.567-24.583h50.521v169.57h-50.521zm318.777 39.583c8.615 0 15.624 7.009 15.624 15.625s-7.009 15.625-15.624 15.625h-39.198v30h39.198c8.615 0 15.624 7.009 15.624 15.625 0 8.615-7.009 15.625-15.624 15.625h-39.198v30h39.198c8.615 0 15.624 7.009 15.624 15.625 0 8.615-7.009 15.625-15.624 15.625l-183.159-.001-55.096-19.385v-181.545l4.139-3.172c22.766-17.451 41.508-40.272 54.201-65.996s19.402-54.482 19.402-83.167v-16.758c19.047 1.929 33.961 18.058 33.961 37.604v117.42h126.552c8.615 0 15.624 7.009 15.624 15.625 0 8.615-7.009 15.625-15.624 15.625h-39.198v30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 0h30v40.49h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.148 31.419h30v40.49h-30z",
    transform: "matrix(.707 -.707 .707 .707 16.232 142.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.484 112.516h40.49v30h-40.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.025 112.516h40.49v30h-40.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.606 36.664h40.49v30h-40.49z",
    transform: "matrix(.707 -.707 .707 .707 60.665 249.786)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndorsement);
export default __webpack_public_path__ + "static/media/endorsement.c183ef20f5326a25efe1defee8e41904.svg";
export { ForwardRef as ReactComponent };